export default "__VITE_ASSET__C69PI21b__"